import { isPlatformServer } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { LocalStorageService } from 'src/app/shared/services/local-storage.service';

@Injectable({
	providedIn: 'root',
})
export class AuthGuard {
	user: any;
	constructor(
		private router: Router,
		public localStorage: LocalStorageService,
		@Inject(PLATFORM_ID) private platformId: Object
	) {}

	canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
		if (isPlatformServer(this.platformId)) {
			return true;
		}
		this.user = this.localStorage.getItem('ROD-logged.user');
		
		// Verificar si hay usuario y token válido
		if (this.user !== undefined && this.user !== null) {
			try {
				const parsedUser = JSON.parse(this.user);
				if (parsedUser?.token) {
					return true;
				}
			} catch (error) {
				// Si hay error parseando, limpiar datos corruptos
				console.error('Error parsing user data in AuthGuard:', error);
				this.localStorage.clear();
			}
		}
		
		// No hay usuario válido o token inválido, limpiar localStorage y redirigir
		// Esto previene que datos residuales queden cuando el token es inválido
		this.localStorage.clear();
		this.router.navigate(['/conta/login']);
		return false;
	}
}
